import { OPERATORS } from "../../../constants/operators";

export const getOperators = (fieldName, fields, t) => {
  const field = fields.find((fld) => fld.name === fieldName);

  let operatorLabels;

  // Determine the operators and labels based on the dataType
  switch (field.dataType) {
  default:
  case "text":
    operatorLabels = {
      [OPERATORS.IS]: t("components.queryBuilder.operators.is"),
      [OPERATORS.IS_NOT]: t("components.queryBuilder.operators.isNot"),
      [OPERATORS.CONTAINS]: t("components.queryBuilder.operators.contains"),
      [OPERATORS.DOES_NOT_CONTAIN]: t("components.queryBuilder.operators.doesNotContain"),
    };
    break;
  case "number":
    operatorLabels = {
      [OPERATORS.IS]: t("components.queryBuilder.operators.equal"),
      [OPERATORS.IS_NOT]: t("components.queryBuilder.operators.notEqual"),
      [OPERATORS.LESS_THAN]: t("components.queryBuilder.operators.lessThan"),
      [OPERATORS.LESS_THAN_OR_EQUAL]: t("components.queryBuilder.operators.lessThanOrEqual"),
      [OPERATORS.GREATER_THAN]: t("components.queryBuilder.operators.greaterThan"),
      [OPERATORS.GREATER_THAN_OR_EQUAL]: t("components.queryBuilder.operators.greaterThanOrEqual"),
    };
    break;
  case "boolean":
    operatorLabels = {
      [OPERATORS.IS]: t("components.queryBuilder.operators.is"),
      [OPERATORS.IS_NOT]: t("components.queryBuilder.operators.isNot"),
    };
    break;
  case "date":
    operatorLabels = {
      [OPERATORS.IS]: t("components.queryBuilder.operators.is"),
      [OPERATORS.LESS_THAN]: t("components.queryBuilder.operators.before"),
      [OPERATORS.GREATER_THAN]: t("components.queryBuilder.operators.after"),
      [OPERATORS.BETWEEN]: t("components.queryBuilder.operators.between"),
    };
    break;
  }

  // Check if filterOptions is defined and use it to filter the operators
  if (field.filterParams && field.filterParams.filterOptions) {
    return field.filterParams.filterOptions.map((filterOption) => {
      return {
        name: filterOption,
        label: operatorLabels[filterOption] || filterOption,
      };
    });
  }

  // If filterOptions is not defined, return the default set of operators based on dataType
  return Object.entries(operatorLabels).map(([name, label]) => ({
    name,
    label,
  }));
};
